export function resolveApiBaseUrl(
  fromEnv: string | undefined,
  origin: string,
): string {
  const current = new URL(origin);
  const isLocalHost =
    current.hostname === "localhost" || current.hostname === "127.0.0.1";

  const trimmed = fromEnv?.trim();
  if (trimmed) {
    const normalized = trimmed.replace(/\/$/, "");
    try {
      const configured = new URL(normalized);
      const configuredIsLocalHost =
        configured.hostname === "localhost" ||
        configured.hostname === "127.0.0.1";
      if (!configuredIsLocalHost || isLocalHost) {
        return configured.origin;
      }
    } catch {
      if (isLocalHost) {
        return normalized;
      }
    }
  }

  if (current.port === "3004") {
    current.port = "8084";
    return current.origin;
  }

  if (isLocalHost || current.port === "3000" || current.port === "3002") {
    current.port = "8080";
    return current.origin;
  }

  return "https://api.passiveagents.com";
}
